"use client";

import { useSearchParams } from "next/navigation";
import { ArrowLeft } from "lucide-react";
import Link from "next/link";

export default function BackButton() {
  const searchParams = useSearchParams();
  const from = searchParams.get("from");

  return (
    <Link
      href={from || "/forum/jcg"}
      className="inline-flex items-center gap-1 text-sm text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200 mb-6"
    >
      <ArrowLeft className="h-4 w-4" />
      {from ? "원래 문제로 돌아가기" : "문제 포럼으로 돌아가기"}
    </Link>
  );
}
